import React from 'react';
import { Row, Col } from 'antd';
import Button from 'components/Core/Button';
import { EventRow, EventDateTimeRow, EventContentRow } from './styles';
import { WebsiteImage } from 'components/TitleDescription';
import dayJs from 'utils/date';

const WorkshopEvent = ({ workshop, eventDate, registrationLink }) => {
  const startDate = dayJs.tz(eventDate, 'America/Los_Angeles');

  return (
    <EventRow gutter={40}>
      <Col md={8} xs={24}>
        <WebsiteImage
          src={workshop[0]?.featuredImage.image}
          alt={workshop[0]?.featuredImage?.alt}
        />
      </Col>
      <Col md={16} xs={24}>
        <EventDateTimeRow>
          <Col>
            <p>{startDate.format('MMMM D, YYYY')}</p>
          </Col>
        </EventDateTimeRow>
        <EventContentRow>
          <h5>
            {workshop[0]?.title} ({workshop[0]?.duration}
          </h5>
          <p>{workshop[0]?.excerpt.excerpt}</p>
        </EventContentRow>
        <Row>
          <Button
            type="secondary"
            size="small"
            to={registrationLink || workshop[0]?.registrationLink}
          >
            Register Now
          </Button>
        </Row>
      </Col>
    </EventRow>
  );
};

export default WorkshopEvent;
